import React from "react";

import styles from "./styles.module.scss";

// assets
import SendIcon from "src/assets/images/home/send.svg";

const Item = ({ data, icon, handleClick }) => {
  return (
    <li className={styles.item__wrapper} onClick={() => handleClick(data)}>
      {!icon ? (
        <img src={data?.imgpath} alt="las vegas" />
      ) : (
        <div className={styles.icon__wrapper}>
          <img src={SendIcon} alt="send" />
        </div>
      )}
      <div>
        <h4>{data?.city || data?.name}</h4>
        <p>
          {data?.state} {data?.distance && <span>{data?.distance}</span>}
        </p>
      </div>
    </li>
  );
};

export default Item;
